

export const PRODUCTO_DESCRIPCION_SEGURO = 'AP Segmentos Especiales';